import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c9f6afb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box container" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-11" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "column is-1" }
const _hoisted_6 = { class: "card-header-icon" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = {
  key: 0,
  class: "notification is-light content"
}
const _hoisted_9 = { class: "video-grid-container" }
const _hoisted_10 = { class: "message is-info" }
const _hoisted_11 = { class: "message-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Descripción", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_i_frame = _resolveComponent("vue-i-frame")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, " Video: " + _toDisplayString(this.video?.title), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createVNode(_component_router_link, { to: { name: 'public-videos' } }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_svg_icon, {
                  type: "mdi",
                  path: _ctx.mdiArrowLeft
                }, null, 8, ["path"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (_ctx.fullLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(), _createBlock(_component_vue_i_frame, {
              key: this.video?.url,
              class: "video-grid-main",
              src: this.video?.url
            }, null, 8, ["src"]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("article", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createTextVNode(": " + _toDisplayString(this.video?.description), 1)
      ])
    ])
  ]))
}